/**
 * Condense a name to the initials an avatar shows when it has no image.
 *
 * Lives apart from Avatar.tsx so that file only exports a component — mixing
 * the two breaks Vite's fast refresh.
 *
 * "E2E Alpha" -> "EA", "NawBrah" -> "N". Two words is the useful limit; three
 * letters in a 32px circle is unreadable. One or two characters pass through
 * untouched, so callers that already supply initials are unaffected.
 */
export function toInitials(value: string): string {
  const trimmed = value.trim()
  // A blank name is not a blank avatar — an empty circle reads as a broken
  // image rather than as "no picture".
  if (trimmed.length === 0) return '?'
  if (trimmed.length <= 2) return trimmed.toUpperCase()

  // `trimmed` is non-empty by here, so the split always yields a word.
  const words = trimmed.split(/\s+/).filter(Boolean)
  if (words.length === 1) return [...words[0]][0].toUpperCase()
  return words
    .slice(0, 2)
    .map((w) => [...w][0].toUpperCase())
    .join('')
}
